<template>
  <v-list-item @click="goTo()">
    <v-list-item-avatar>
      <v-icon>
        {{ icon }}
      </v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title>{{ navigationItem.title }}</v-list-item-title>

      <v-list-item-subtitle>{{ navigationItem.description }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script lang="ts">
import { resolveNavigationIcon } from "@/lib/utility/navigation-icon";
import { NavigationRoute } from "@/store/mapper/navigation.route";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class NavigationListItem extends Vue {
  @Prop()
  navigationItem!: NavigationRoute;

  get icon() {
    return resolveNavigationIcon(this.navigationItem?.navigation?.icon) || "mdi-alert-circle-outline";
  }

  get partnerId() {
    return PartnerModule.partner.id;
  }

  /**
   * Navigates to the route of the item and reports the selection to the parent, so that an overlay
   * rendering the item - see `CommandPalette` - can close itself. Emitted before navigating: the
   * overlay must close even when the navigation does not complete.
   */
  goTo() {
    this.$emit("click");

    this.$router.push({ name: this.navigationItem.name, params: { partnerId: this.partnerId } });
  }
}
</script>
